import { AuthServices } from '@/features/auth/services';
import { auth } from '@/features/auth/types';

/** A player linked to the signed-in guardian, from `GET /api/v1/guardians/me/players`. */
export type GuardianPlayer = auth.GuardianPlayer;

export async function fetchGuardianPlayers(): Promise<GuardianPlayer[]> {
  return await AuthServices.getGuardianPlayers();
}
